import { PERSISTENT_MENU_ITEM_CLICK } from "actions/const";
import webbotActions from "./webbot";

function persistentMenuItemClick(type, label, options) {
  return dispatch => {
    if (type === 1) {
      // Send message
      dispatch(
        webbotActions.sendMessage({
          label,
          message: options.get("message"),
          save: true,
          ref: null,
          showLabel: true,
        })
      );
    } else if (type === 3) {
      window.open(options.get("newtab_url"), "_blank");
    }
    return {
      type: PERSISTENT_MENU_ITEM_CLICK,
    };
  };
}

export default {
  persistentMenuItemClick,
};
